import styled from "styled-components";

export const Grid = styled.div`
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;

    & > span{
        border-left: 1px solid rgba(0, 0, 0, 0.14);
        display: inline-block;
        height: 100%;
        text-align: right;
        width: 10%;
    }
`;

export const Bar = styled.div`
    margin: 4px 0;
    width: 100%;

    & > label{
        background:rgba(102, 16, 242, 0.24);
        border: 2px solid var(--indigo);
        border-bottom-right-radius: 4px;
        border-left: 1px solid rgba(0, 0, 0, 0.24);
        border-top-right-radius: 4px;
        cursor: default;
        overflow: show;
        white-space: nowrap;
    }
`;